"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandName = void 0;
const brands_1 = require("./brands");
const config_1 = require("./config");
const envToBusinessUnit_1 = require("./envToBusinessUnit");
const getBrandName = () => {
    const currentBrand = config_1.envConfig.currentBrand || brands_1.CurrentBrandEnv.BOT;
    if (Object.values(brands_1.CurrentBrandEnv).some((brand) => brand === brand)) {
        return envToBusinessUnit_1.envToBusinessUnit[currentBrand];
    }
    return envToBusinessUnit_1.envToBusinessUnit[brands_1.CurrentBrandEnv.BOT];
};
exports.getBrandName = getBrandName;
